var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 8.5C14.4 7.6176 13.6824 6.9 12.8 6.9H12V4.5C12 2.2944 10.2056 0.5 8.00001 0.5C5.79441 0.5 4.00001 2.2944 4.00001 4.5V6.9H3.20001C2.31761 6.9 1.60001 7.6176 1.60001 8.5V14.9C1.60001 15.7824 2.31761 16.5 3.20001 16.5H12.8C13.6824 16.5 14.4 15.7824 14.4 14.9V8.5ZM5.60001 4.5C5.60001 3.1768 6.67681 2.1 8.00001 2.1C9.32321 2.1 10.4 3.1768 10.4 4.5V6.9H5.60001V4.5Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.40fa3f536ad110cdb7339e467947263c.svg";
export { ForwardRef as ReactComponent };